module.exports = __webpack_public_path__ + "static/media/slide2.b5e8fbbb.jpg";